import { gql } from '@apollo/client';

export const MY_TEAM_STATUS = gql`
  query MyTeamStatus {
    myTeamStatus {
      userId
      status
      statusSetAt
      officeName
      propertyName
      contextSetAt
      contextSource
    }
  }
`;

export const UPDATE_MY_TEAM_STATUS = gql`
  mutation UpdateMyTeamStatus($input: UpdateTeamStatusInput!) {
    updateMyTeamStatus(input: $input) {
      userId
      status
      statusSetAt
      officeName
      propertyName
      contextSetAt
      contextSource
    }
  }
`;

export const TEAM_STATUSES_FOR_USERS = gql`
  query TeamStatusesForUsers($userIds: [Int!]!) {
    teamStatuses(userIds: $userIds) {
      userId
      status
      statusSetAt
      officeName
      propertyName
      contextSetAt
      contextSource
    }
  }
`;
